import React from 'react';
import { HourglassIcon } from 'lucide-react';
import { useCountdown } from '../utils/useCountdown';
type CountdownProps = {
  className?: string;
  tone?: 'dark' | 'light';
};
export function CountdownTimer({
  className = '',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hrs'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className={`flex items-stretch justify-center gap-1.5 ${className}`} role="timer" aria-label="Offer countdown" data-id="element-48" data-mp="3h0pgtkd9ntx6">
      {units.map(unit => <div key={unit.label} className={`min-w-[58px] rounded-lg px-2 py-1.5 text-center sm:min-w-[74px] ${tone === 'dark' ? 'bg-ink' : 'bg-white'}`} data-id="element-49" data-mp="324zxjtzgtuw5">
          <span className={`block font-head text-lg tabular-nums leading-none sm:text-2xl ${tone === 'dark' ? 'text-mustard' : 'text-ink'}`} data-id="element-50" data-mp="10cl9sea8pw7t">
            {unit.value}
          </span>
          <span className={`mt-0.5 block text-[8px] font-bold uppercase tracking-widest sm:text-[10px] ${tone === 'dark' ? 'text-white/55' : 'text-muted'}`} data-id="element-51" data-mp="15928g2f2fsz5">
            {unit.label}
          </span>
        </div>)}
    </div>;
}
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return;
}
export function OfferBar() {
  return <section aria-label="Limited-time offer" className="w-full bg-cream px-3 py-6 sm:px-5" data-id="element-52" data-mp="12sety4zhlp3c">
      <div className="mx-auto max-w-2xl rounded-2xl border-2 border-coral bg-white p-4 text-center" data-id="element-53" data-mp="f33tkom1twpq">
        <span className="inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[10px] uppercase tracking-wide text-white sm:text-xs" data-id="element-54" data-mp="a4sh064dd83t">
          Limited-Time Offer
        </span>
        <p className="mt-1.5 font-head text-base uppercase leading-tight text-ink sm:text-xl" data-id="element-55" data-mp="k0m24dw5m9x7">
          Launch price ends in:
        </p>
        <CountdownTimer className="mt-2" data-id="element-56" data-mp="1zk0bpp6ivgge" />
        <p className="mt-2 text-xs leading-snug text-muted" data-id="element-57" data-mp="1vhbzr8mihtf7">
          After that, the price increases and the strategic bonuses may no longer be included.
        </p>

        <div className="mx-auto mt-3 max-w-sm" data-id="element-58" data-mp="x4rb1es071vn">
          <div className="flex items-center justify-between font-head text-[10px] uppercase tracking-wide text-ink sm:text-xs" data-id="element-59" data-mp="x3g7ng2gzw52">
            <span data-id="element-60" data-mp="121q3lsw0r0rq">Limited Availability</span>
            <span className="text-coral" data-id="element-61" data-mp="165piy85kbtji">72% Claimed</span>
          </div>
          <div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-sand" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Availability claimed" data-id="element-62" data-mp="9f5gj4mktatz">
            <div className="h-full rounded-full bg-coral" style={{
            width: '72%'
          }} data-id="element-63" data-mp="ebvwlryds6fe" />
          </div>
        </div>
      </div>
    </section>;
}